import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  noFill,
  className,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30966e-06 11.1856C-0.000638821 11.3032 0.048187 11.421 0.146484 11.5107L9.64725 20.1821C9.84244 20.3603 10.1588 20.3602 10.3538 20.1819C10.5488 20.0036 10.5487 19.7146 10.3535 19.5364L1.68621 11.6257L1.82236 11.6349H23.5C23.7761 11.6349 24 11.4348 24 11.1879C24 10.941 23.7761 10.7408 23.5 10.7408H1.76438L1.69018 10.7464L10.3535 2.8393C10.5487 2.66115 10.5488 2.37217 10.3538 2.19387C10.1588 2.01556 9.84244 2.01544 9.64725 2.1936L0.146484 10.865C0.0494689 10.9536 0.000643027 11.0695 6.30966e-06 11.1856Z"
      />
    </svg>
  );
}
